import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { auth, firestore as db } from "../config/Config";

const  initialState={
    kitchenWickerBasketBasicData:[],
    kitchenWickerBasketBasicLoader:true,
    kitchenWickerBasketBasicError:"",
}

export const fetchKitchenWickerBasketBasicList = createAsyncThunk('fetchKitchenWickerBasketBasic',
async()=>{
    const projectList = await db
    .collectionGroup("wicker_basket_basic")
    // .where("status", "==", "Ongoing")
    // .where("ID", "==", auth.currentUser.uid)
    .get();
  const projectListArray = [];
  for (var snap of projectList.docs) {
    var data = snap.data();
    data.ID = snap.id;
    projectListArray.push({
      ...data,
    });
    if (projectListArray.length === projectList.docs.length) {
      return projectListArray
    }
  }
});

const kitchenWickerBasketBasicReducer = createSlice({
    name:'kitchenWickerBasketBasic',
    initialState,
    reducers:{},
    extraReducers:{
        [fetchKitchenWickerBasketBasicList.fulfilled]:(state,action)=>{
            state.kitchenWickerBasketBasicData = action.payload
            state.kitchenWickerBasketBasicLoader = false
        },
        [fetchKitchenWickerBasketBasicList.pending]:(state,action)=>{
            state.kitchenWickerBasketBasicLoader = true
        },
        [fetchKitchenWickerBasketBasicList.rejected]:(state,action)=>{
            state.kitchenWickerBasketBasicError = "refresh the page"
        },
    }
});

export default kitchenWickerBasketBasicReducer.reducer